import { PesadosBrasilStorage } from './../../../services/pesados-brasil/pesados-brasil.storage';
import { RecoverDataProposalCustomerReference } from './../model/recover-data-proposal/recover-data-proposal-customer-reference';
import { RecoverDataProposalCompanyProvidingService } from './../model/recover-data-proposal/recover-data-proposal-company-providing-service';
import { RecoverDataProposalProfessionalData } from './../model/recover-data-proposal/recover-data-proposal-professional-data';
import { RecoverDataProposalOwnVehicle } from './../model/recover-data-proposal/recover-data-proposal-own-vehicle';
import { RecoverDataProposalAddress } from './../model/recover-data-proposal/recover-data-proposal-address';
import { finalize, take } from 'rxjs/operators';
import {
  Component,
  Input,
  OnInit,
  DoCheck,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { setFichaContent } from '../helpers/salvarFicha';
import { FichaService } from '../../ficha-veiculo.service';
import { FichaCadastro } from './../ficha-cadastro';

import { DadosProfissionais } from '../../../shared/dados-profissionais/model/dados-profissionais';
import { DadosProfissionaisComponent } from '../../../shared/dados-profissionais/dados-profissionais.component';
import { DadosReferenciaComponent } from '../../../shared/dados-referencia/dados-referencia.component';
import { TipoVeiculoEnum } from '../../../produtos/shared/enums/tipo-veiculo.enum';
import { EstadoCivilService } from '../../../services/estado-civil/estado-civil.service';
import moment from 'moment';
import { Referencia } from '../model/referencia';
import { TipoTransporte } from '../../../shared/dados-profissionais/model/tipo-transporte';
import { TipoTransporteService } from '../../../services/tipo-transporte/tipo-transporte.service';
import { Telefone } from '../model/telefone';
import {
  PendenciaCaminhaoProprio,
  PendenciaCaminhaoProprioInfo,
  PendenciaCaminhaoProprioQuitado,
  PendenciaCaminhaoProprioImplemento,
} from './../../ficha-timeline/ficha-modal-avalista/model/veiculo';
import { TelefoneCliente } from '../model/telefone-cliente';
import { Cliente } from '../model/cliente';
import {
  AsyncValidatorFn,
  AbstractControl,
  ValidationErrors,
  NgForm,
} from '@angular/forms';
import { onlyDigits } from '../../../shared/helper/utils';
@Component({
  selector: 'app-ficha-cadastro-detalhe-cliente',
  templateUrl: './ficha-cadastro-detalhe-cliente.component.html',
  styleUrls: ['./ficha-cadastro-detalhe-cliente.component.scss'],
})
export class FichaCadastroDetalheClienteComponent
  implements DoCheck, OnDestroy, OnInit
{
  @Input() fichaCadastro: FichaCadastro;
  @ViewChild('dadosProfissionaisComponent', { static: true })
  dadosProfissionaisComponent: DadosProfissionaisComponent;
  @ViewChild('condutorCaminhao', { static: true }) condutorCaminhao: any;
  @ViewChild('naoCondutorCaminhao', { static: true }) naoCondutorCaminhao: any;
  @ViewChild('prestaServicoOutraEmpresa', { static: true })
  prestaServicoOutraEmpresa: any;
  @ViewChild('naoPrestaServicoOutraEmpresa', { static: true })
  naoPrestaServicoOutraEmpresa: any;
  @ViewChild('clienteReferenciaComponent', { static: true })
  clienteReferenciaComponent: DadosReferenciaComponent;
  @ViewChild('clienteSegundaReferenciaComponent', { static: true })
  clienteSegundaReferenciaComponent: DadosReferenciaComponent;

  @ViewChild('clientePpe', { static: true }) clientePpe: any;
  @ViewChild('clienteNaoPpe', { static: true }) clienteNaoPpe: any;
  @ViewChild('clienteFatca', { static: true }) clienteFatca: any;
  @ViewChild('clienteNaoFatca', { static: true }) clienteNaoFatca: any;
  @ViewChild('segundaReferencia', { static: true }) segundaReferencia: any;
  @ViewChild('formDetalheCliente', { static: false })
  formDetalheCliente: NgForm;

  private nomeClienteOriginal: string;

  nomeCliente: string;
  emailCliente: string;
  tipoDocumentoCliente = 0;
  numeroDocumentoCliente: string;
  orgaoDocumentoCliente: string;
  emissaoDocumentoCliente: string;
  foneCelularCliente: string;
  estadoCivilCliente = 0;
  nomeRealMaeCliente = '';
  nomeMaeCliente = '';
  nomePaiCliente: string;
  nacionalidadeCliente = 1;
  naturalUfCliente = '';
  naturalCidadeCliente = '';
  valorPatrimonioCliente: number;
  ppeCliente = false;
  referenciaFormValid: false;
  segundaReferenciaFormValid: false;

  isOutraPessoaCliente = false;
  isNomeMaeCliente = false;
  isNomePaiCliente = false;

  subsNomeMaeCliente: Subscription;
  subsNacionalidadeCliente: Subscription;
  subsNaturalCidadeCliente: Subscription;
  subsProfissaoCliente: Subscription;

  listaNomeMaeCliente = [];
  listaNacionalidadeCliente = [];
  listaNaturalCidadeCliente = [];
  listaClasseProfissionalCliente = [];
  listaProfissaoCliente = [];
  listaEstadosCivis = [];

  isLoadingNomeMaeCliente = false;
  isLoadingNacionalidadeCliente = false;
  isLoadingNaturalCidadeCliente = false;
  isLoadingProfissaoCliente = false;
  isLoadingEstadosCivis = false;

  isSelectedTipoDocumentoCliente = false;
  isSelectedEstadoCivilCliente = false;
  isSelectedNomeMaeCliente = false;
  isSelectedBrasilCliente = true;
  isSelectedNaturalUfCliente = false;
  isSelectedNaturalCidadeCliente = false;
  isSelectedClasseProfissionalCliente = false;
  isSelectedSegundaReferencia = false;

  minDataEmissao: string;
  maxDataEmissao: string;

  hasData = false;

  isLoadedListaNomeMaeCliente = true;

  isSelectedNomeMaeClienteAfterBlur = true;
  isSelectedNaturalCidadeClienteAfterBlur = true;

  isNomeMaeClienteTexto = false;
  isNomePaiClienteTexto = false;

  dadoProfissional;

  isLoadingTipoTransporte = false;
  showOutroTipoTransporte = false;
  showOutroTipoTransporteRecoverData = false;
  tipoTransporteTouched = false;
  outroTipoTransporteTouched = false;
  showOutroTipoTransporteOutraEmpresa = false;
  showOutroTipoTransporteOutraEmpresaRecoverData = false;
  tipoTransporteOutraEmpresaTouched = false;
  outroTipoTransporteOutraEmpresaTouched = false;

  listaTipoTransporte: TipoTransporte[] = [];

  isSemPaiNoRegistro = false;

  public errorMessage: string;
  private setted: boolean = false;
  private settedEmail: boolean = false;
  public errorMessageEmail: string;

  constructor(
    private readonly fichaService: FichaService,
    private readonly estadoCivilService: EstadoCivilService,
    private readonly tipoTransporteService: TipoTransporteService,
    private readonly pesadosBrasilStorage: PesadosBrasilStorage
  ) {}

  ngOnInit() {
    this.loadTipoTransporte();
  }

  ngDoCheck() {
    if (!this.hasData && this.fichaCadastro.proposta['id']) {
      if (!this.fichaCadastro.getFichaLocalStorage) {
        this.setDadosRecuperados();
      }
      this.nomeClienteOriginal = this.fichaCadastro.proposta['cliente']['nome'];
      this.nomeCliente = this.nomeClienteOriginal;
      this.isOutraPessoaCliente = false;
      this.isNomeMaeCliente = true;
      this.isNomeMaeClienteTexto = false;
      this.isNomePaiCliente = true;
      this.isNomePaiClienteTexto = false;
      this.loadNomeMaeCliente();
      this.loadNacionalidadeCliente();
      this.loadEstadosCivis();
      this.hasData = true;
    }
    if (this.fichaCadastro.setDadosCliente) {
      this.fichaCadastro.setDadosCliente = false;
      this.assignFichaCadastroClient();
    }
    if (
      this.formDetalheCliente &&
      this.formDetalheCliente.controls &&
      this.formDetalheCliente.controls['email'] &&
      !this.settedEmail
    ) {
      this.settedEmail = true;
      this.formDetalheCliente.controls['email'].setAsyncValidators(
        this.validEmail()
      );
    }
    if (
      this.fichaCadastro._client &&
      this.fichaCadastro._client.empresaPrestacaoServico &&
      this.fichaCadastro._client.empresaPrestacaoServico.telefone &&
      !this.setted
    ) {
      // tslint:disable
      this.formDetalheCliente.controls[
        'telefoneOutraEmpresa'
      ].setAsyncValidators(this.validCelphone());

      this.setted = true;
      // tslint:enable
    }
  }

  ngOnDestroy() {
    if (this.subsNomeMaeCliente) {
      this.subsNomeMaeCliente.unsubscribe();
    }
    if (this.subsNacionalidadeCliente) {
      this.subsNacionalidadeCliente.unsubscribe();
    }
    if (this.subsNaturalCidadeCliente) {
      this.subsNaturalCidadeCliente.unsubscribe();
    }
    if (this.subsProfissaoCliente) {
      this.subsProfissaoCliente.unsubscribe();
    }
  }

  setDadosRecuperados() {
    let { cliente } = this.fichaCadastro.proposta;
    if (!cliente || this.fichaCadastro.setDadosCliente) {
      cliente = this.fichaCadastro._client;
    }

    this.fichaCadastro._client.email = cliente.email;
    this.fichaCadastro._client.nomePai = cliente.nomePai;
    this.fichaCadastro._client.idTipoDocumento =
      cliente.documento && cliente.documento.tipo
        ? cliente.documento.tipo
        : cliente.idTipoDocumento;
    this.fichaCadastro._client.rgIe =
      cliente.documento && cliente.documento.numero
        ? cliente.documento.numero
        : cliente.rgIe;
    this.fichaCadastro._client.rgIeData = new Date(
      (cliente.documento || {}).dataEmissao
    ).toLocaleDateString('pt-BR');
    this.fichaCadastro._client.rgIeEmissor =
      cliente.documento && cliente.documento.emissor
        ? cliente.documento.emissor
        : cliente.rgIeIssuer;
    this.fichaCadastro._client.idNacionalidade = cliente.idNacionalidade;
    this.fichaCadastro._client.naturalDe = cliente.naturalDe;
    this.fichaCadastro._client.naturalDeUf = cliente.naturalDeUf;
    this.loadNaturalCidadeCliente();
    this.fichaCadastro._client.enderecos = this.getEnderecoTipo(1);
    this.fichaCadastro._client.tipoEnderecoCorrespondencia =
      cliente.enderecos && cliente.enderecos.length > 0
        ? this.getTipoEnderecoCorrespondencia()
        : undefined;
    this.fichaCadastro._client.enderecoCorrespondencia =
      this.getEnderecoTipo(7);
    this.fichaCadastro._client.valorPatrimonio = cliente.valorPatrimonio;
    this.fichaCadastro._client.idEstadoCivil = cliente.idEstadoCivil;
    this.fichaCadastro._client.clientePpe = cliente.clientePpe;
    this.fichaCadastro._client.fatca = cliente.fatca;
    this.setClientePpeIfSelected();
    this.setFatcaIfSelected();
    if (!this.fichaCadastro._client.telefones) {
      this.fichaCadastro._client.telefones = new TelefoneCliente();
      this.fichaCadastro._client.telefones.celularAdicional =
        this.getTelefoneCategoria(11);
      this.fichaCadastro._client.telefones.residencial =
        this.getTelefoneCategoria(1);
      this.fichaCadastro._client.telefones.comercial =
        this.getTelefoneCategoria(14);
    }

    if (this.isPesados || this.fichaCadastro._client.condutorCaminhao) {
      this.setCondutorCaminhaoIfSelected();
      this.setTipoTransporteIfSelected();
      this.setTipoTransporteOutraEmpresaIfSelected();
      this.setPrestaServicoOutraEmpresaIfSelected();
    }

    if (cliente.clienteReferencias.length > 0) {
      this.setClienteReferencia(cliente.clienteReferencias);
    }

    if (
      cliente.dadoProfissional &&
      cliente.dadoProfissional.length > 0 &&
      cliente.dadoProfissional[0].idProfissao !== 0
    ) {
      this.setDadoProfissional(cliente.dadoProfissional[0]);
    }
  }

  private setCondutorCaminhaoIfSelected() {
    if (this.fichaCadastro._client.condutorCaminhao === 'S') {
      this.condutorCaminhao.value = true;
      this.naoCondutorCaminhao.value = false;
    } else {
      this.fichaCadastro._client.condutorCaminhao = 'N';
      this.condutorCaminhao.value = false;
      this.naoCondutorCaminhao.value = true;
    }
  }

  setDadoProfissional(dadoProfissional) {
    const dadosProfissionais = new DadosProfissionais();
    dadosProfissionais.empresa.nome = dadoProfissional.nomeEmpresa;
    dadosProfissionais.empresa.telefone = `${
      dadoProfissional.trabalhoAnteriorDDD +
      dadoProfissional.trabalhoAnteriorTelefone
    }`;
    dadosProfissionais.empresa.endereco = this.getEnderecoTipo(2);
    dadosProfissionais.classeProfissional = {
      id: dadoProfissional.idClasseProfissional,
      descricao: '',
      empresa: true,
    };
    dadosProfissionais.profissao = {
      id: dadoProfissional.idProfissao,
      descricao: '',
      idGrupoProfissao: dadoProfissional.idGrupoProfissao,
    };
    dadosProfissionais.dadosSelected();

    this.dadosProfissionaisComponent.setDadosRecuperados(dadosProfissionais);
  }

  setClienteReferencia(clienteReferencias: Referencia[]) {
    this.clienteReferenciaComponent.setDadosRecuperados(clienteReferencias[0]);
    if (clienteReferencias[1]) {
      this.segundaReferencia.value = true;
      this.isSelectedSegundaReferencia = true;
      this.clienteSegundaReferenciaComponent.setDadosRecuperados(
        clienteReferencias[1]
      );
    }
  }

  private setTipoTransporteIfSelected() {
    if (this.fichaCadastro._client.tipoTransporte) {
      this.onChangeTipoTransporte();
    }
  }

  private setTipoTransporteOutraEmpresaIfSelected() {
    if (this.fichaCadastro._client.empresaPrestacaoServico.tipoTransporte) {
      this.onChangeTipoTransporteOutraEmpresa();
    }
  }

  private setPrestaServicoOutraEmpresaIfSelected() {
    if (this.fichaCadastro._client.prestaServicoOutraEmpresa === 'S') {
      this.prestaServicoOutraEmpresa.value = true;
      this.naoPrestaServicoOutraEmpresa.value = false;
    } else {
      this.fichaCadastro._client.prestaServicoOutraEmpresa = 'N';
      this.prestaServicoOutraEmpresa.value = false;
      this.naoPrestaServicoOutraEmpresa.value = true;
    }
  }

  setPrestaServicoOutraEmpresa(event) {
    const component = <HTMLInputElement>event.target;

    if (component.id === 'prestaServicoOutraEmpresa') {
      this.naoPrestaServicoOutraEmpresa.value = !component.checked;
      this.fichaCadastro._client.prestaServicoOutraEmpresa = component.checked
        ? 'S'
        : 'N';
    } else {
      this.prestaServicoOutraEmpresa.value = !component.checked;
      this.fichaCadastro._client.prestaServicoOutraEmpresa = component.checked
        ? 'N'
        : 'S';
    }
  }

  private setClientePpeIfSelected() {
    if (this.fichaCadastro._client.clientePpe === 'S') {
      this.clientePpe.value = true;
      this.clienteNaoPpe.value = false;
    } else if (this.fichaCadastro._client.clientePpe === 'N') {
      this.clientePpe.value = false;
      this.clienteNaoPpe.value = true;
    }
  }

  private setFatcaIfSelected() {
    if (this.fichaCadastro._client.fatca) {
      this.clienteFatca.value = true;
      this.clienteNaoFatca.value = false;
    } else {
      this.clienteFatca.value = false;
      this.clienteNaoFatca.value = true;
    }
  }

  getTelefoneCategoria(idCategoria) {
    let currentPhone = '';
    if (
      this.fichaCadastro.proposta.cliente &&
      this.fichaCadastro.proposta.cliente.telefones &&
      this.fichaCadastro.proposta.cliente.telefones.length
    ) {
      this.fichaCadastro.proposta.cliente.telefones.forEach((telefone) => {
        if (telefone.idCategoria === idCategoria) {
          currentPhone = `${telefone.ddd + telefone.numero}`;
        }
      });
    }

    return currentPhone;
  }

  getEnderecoTipo(idTipoEndereco) {
    let currentEndereco;
    if (this.fichaCadastro.proposta.enderecos) {
      this.fichaCadastro.proposta.cliente.enderecos.forEach((endereco) => {
        if (endereco && endereco.idTipoEndereco === idTipoEndereco) {
          currentEndereco = endereco;
        }
      });
    }

    return currentEndereco;
  }

  getTipoEnderecoCorrespondencia() {
    let tipoEnderecoCorrespondencia;
    this.fichaCadastro.proposta.cliente.enderecos.forEach((endereco) => {
      if (endereco.correspondencia) {
        tipoEnderecoCorrespondencia = endereco.idTipoEndereco;
      } else {
        tipoEnderecoCorrespondencia = '7';
      }
    });

    return tipoEnderecoCorrespondencia;
  }

  loadNomeMaeCliente() {
    this.listaNomeMaeCliente = [];
    this.isLoadingNomeMaeCliente = false;
    this.subsNomeMaeCliente = this.fichaService
      .getListaNomeMae(
        this.fichaCadastro.proposta['id'],
        this.fichaCadastro.proposta['cliente']['id']
      )
      .pipe(finalize(() => (this.isLoadingNomeMaeCliente = false)))
      .subscribe(
        (res) => {
          this.listaNomeMaeCliente = res.nomes;
          this.handleMissingNomeMaeCliente();
        },
        () => this.handleMissingNomeMaeCliente()
      );
  }

  private handleMissingNomeMaeCliente(): void {
    if (this.listaNomeMaeCliente.length === 0) {
      this.isNomeMaeCliente = false;
      this.isNomeMaeClienteTexto = true;
      this.isLoadedListaNomeMaeCliente = false;
    }
  }

  loadNacionalidadeCliente() {
    this.listaNacionalidadeCliente = [];
    this.isLoadingNacionalidadeCliente = true;
    this.subsNacionalidadeCliente = this.fichaService
      .getAllNacionalidade()
      .subscribe(
        (res) => {
          this.listaNacionalidadeCliente = res.nacionalidades;
          this.isLoadingNacionalidadeCliente = false;
          if (this.fichaCadastro._client.naturalDeUf) {
            this.loadNaturalCidadeCliente();
          } else {
            this.isLoadingNacionalidadeCliente = false;
          }
          this.fillNacionalidade(res);
        },
        (err) => {
          this.isLoadingNacionalidadeCliente = false;
        }
      );
  }

  fillNacionalidade(res) {
    if (!this.fichaCadastro._client.idNacionalidade) {
      res.nacionalidades.forEach((nacionalidade) => {
        if (nacionalidade.descricao === 'BRASILEIRA') {
          this.fichaCadastro._client.idNacionalidade = nacionalidade.id;
        }
      });
    }
  }

  getIdNacionalidade(data) {
    if (data !== '1') {
      this.fichaCadastro._client.naturalDeUf = '';
      this.fichaCadastro._client.naturalDe = '';
    }
  }

  loadNaturalCidadeCliente() {
    this.listaNaturalCidadeCliente = [];
    if (this.fichaCadastro._client.naturalDeUf) {
      this.isSelectedNaturalCidadeCliente = false;
      this.isLoadingNaturalCidadeCliente = true;
      this.subsNaturalCidadeCliente = this.fichaService
        .getCidadePorUf(this.fichaCadastro._client.naturalDeUf)
        .subscribe(
          (res) => {
            this.listaNaturalCidadeCliente = res.cidades;
            this.isLoadingNaturalCidadeCliente = false;
          },
          (err) => {
            this.isLoadingNaturalCidadeCliente = false;
          }
        );
    }
  }

  loadEstadosCivis() {
    this.isLoadingEstadosCivis = true;
    this.estadoCivilService
      .getEstadosCivis()
      .pipe(
        take(1),
        finalize(() => (this.isLoadingEstadosCivis = false))
      )
      .subscribe((res) => {
        this.listaEstadosCivis = res;
      });
  }

  loadTipoTransporte() {
    this.isLoadingTipoTransporte = true;
    this.tipoTransporteService
      .getTipoTransporte()
      .pipe(
        take(1),
        finalize(() => (this.isLoadingTipoTransporte = false))
      )
      .subscribe((res) => {
        this.listaTipoTransporte = res.transportes;
      });
  }

  onClickOutraPessoaCliente() {
    this.isOutraPessoaCliente = !this.isOutraPessoaCliente;
    this.nomeCliente = this.isOutraPessoaCliente
      ? ''
      : this.nomeClienteOriginal;
  }

  onClickNomeMaeCliente() {
    this.isNomeMaeCliente = !this.isNomeMaeCliente;
    this.isNomeMaeClienteTexto = !this.isNomeMaeClienteTexto;
  }

  onClickNomePaiCliente() {
    this.isNomePaiCliente = !this.isNomePaiCliente;
    this.isNomePaiClienteTexto = !this.isNomePaiClienteTexto;

    if (!this.isNomePaiCliente) {
      this.fichaCadastro._client.nomePai = 'NAO DECLARADO';
      this.isSemPaiNoRegistro = true;
    } else {
      this.fichaCadastro._client.nomePai = '';
      this.isSemPaiNoRegistro = false;
    }
  }

  onChangeNomeMaeCliente(event) {
    this.nomeRealMaeCliente = event.target.value;
    this.nomeMaeCliente =
      this.listaNomeMaeCliente[event.target.selectedIndex - 1].nomeMae;
    this.isSelectedNomeMaeCliente = event.target.selectedIndex !== 0;
    this.onBlurNomeMaeCliente(event);
  }

  onChangeNaturalUfCliente(event) {
    this.naturalUfCliente = event.target.value;
    this.isSelectedNaturalUfCliente = true;
    this.naturalCidadeCliente = '';
    this.isSelectedNaturalCidadeCliente = false;
    this.loadNaturalCidadeCliente();
  }

  onChangeNaturalCidadeCliente(event) {
    this.naturalCidadeCliente = event.target.value;
    this.isSelectedNaturalCidadeCliente = event.target.selectedIndex !== 0;
    this.onBlurNaturalCidadeCliente(event);
  }

  onBlurNomeMaeCliente(event) {
    this.isSelectedNomeMaeClienteAfterBlur = event.target.selectedIndex !== 0;
  }

  onBlurNaturalCidadeCliente(event) {
    this.isSelectedNaturalCidadeClienteAfterBlur =
      event.target.selectedIndex !== 0;
  }

  setCondutorCaminhao(event) {
    const component = <HTMLInputElement>event.target;

    if (component.id === 'condutorCaminhao') {
      this.naoCondutorCaminhao.value = !component.checked;
      this.fichaCadastro._client.condutorCaminhao = component.checked
        ? 'S'
        : 'N';
    } else {
      this.condutorCaminhao.value = !component.checked;
      this.fichaCadastro._client.condutorCaminhao = component.checked
        ? 'N'
        : 'S';
    }
  }

  onChangeTipoTransporte() {
    this.tipoTransporteTouched = true;

    this.showOutroTipoTransporte = this.listaTipoTransporte.some((item) => {
      return (
        item.id === this.fichaCadastro._client.tipoTransporte &&
        item.edicao === 'S'
      );
    });
  }

  onBlurOutroTipoTransporte() {
    if (
      this.fichaCadastro._client.tipoTransporteOutro === null &&
      this.showOutroTipoTransporte
    ) {
      this.outroTipoTransporteTouched = true;
    }
  }

  get tipoTransporteValid() {
    if (
      this.fichaCadastro._client.tipoTransporte !== null &&
      this.fichaCadastro._client.tipoTransporte !== undefined
    ) {
      return (
        this.fichaCadastro._client.tipoTransporte !== null &&
        this.fichaCadastro._client.tipoTransporte !== undefined &&
        this.tipoTransporteTouched
      );
    }
  }

  onChangeTipoTransporteOutraEmpresa() {
    this.tipoTransporteOutraEmpresaTouched = true;

    this.showOutroTipoTransporteOutraEmpresa = this.listaTipoTransporte.some(
      (item) => {
        return (
          item.id ===
            this.fichaCadastro._client.empresaPrestacaoServico.tipoTransporte &&
          item.edicao === 'S'
        );
      }
    );
  }

  onBlurOutroTipoTransporteOutraEmpresa() {
    if (
      this.fichaCadastro._client.empresaPrestacaoServico.tipoTransporteOutro ===
        null &&
      this.showOutroTipoTransporteOutraEmpresa
    ) {
      this.outroTipoTransporteOutraEmpresaTouched = true;
    }
  }

  get tipoTransporteOutraEmpresaValid() {
    if (this.fichaCadastro._client.empresaPrestacaoServico.tipoTransporte) {
      return (
        this.fichaCadastro._client.empresaPrestacaoServico.tipoTransporte &&
        this.tipoTransporteOutraEmpresaTouched
      );
    }
  }

  setClientePpe(event) {
    const component = <HTMLInputElement>event.target;

    if (component.id === 'clientePpe') {
      this.clienteNaoPpe.value = !component.checked;
      this.fichaCadastro._client.clientePpe = component.checked ? 'S' : 'N';
      return;
    }

    this.clientePpe.value = !component.checked;
    this.fichaCadastro._client.clientePpe = component.checked ? 'N' : 'S';
  }

  setFatca(event) {
    const component = <HTMLInputElement>event.target;

    if (component.id === 'clienteFatca') {
      this.clienteNaoFatca.value = !component.checked;
      this.fichaCadastro._client.fatca = component.checked ? true : false;
      return;
    }

    this.clienteFatca.value = !component.checked;
    this.fichaCadastro._client.fatca = component.checked ? false : true;
  }

  onClickSegundaReferencia() {
    this.isSelectedSegundaReferencia = !this.isSelectedSegundaReferencia;
  }

  onChangeReferencia(referenciaForm) {
    this.fichaCadastro._client.clienteReferencias[0] =
      this.mapClienteReferencia(referenciaForm);
  }

  onChangeSegundaReferencia(segundaReferenciaForm) {
    this.fichaCadastro._client.clienteReferencias[1] =
      this.mapClienteReferencia(segundaReferenciaForm);
  }

  mapClienteReferencia(referenciaForm) {
    return {
      nome: String(referenciaForm.nome),
      idGrauRelacionamento: Number(referenciaForm.idGrauRelacionamento),
      relacaoClienteOutro: referenciaForm.relacaoClienteOutro
        ? referenciaForm.relacaoClienteOutro
        : undefined,
      telefones: this.mapTelefonesReferencia(referenciaForm),
    };
  }

  private mapTelefonesReferencia(referenciaForm) {
    const arrayFones: Telefone[] = [];
    arrayFones.push({
      ddd:
        referenciaForm && referenciaForm.foneCelular
          ? referenciaForm.foneCelular.substring(0, 2)
          : undefined,
      numero:
        referenciaForm && referenciaForm.foneCelular
          ? referenciaForm.foneCelular.substring(2)
          : undefined,
      idCategoria: '3',
      idTipoTelefone: '1',
      idCategoriaTelefone: '3',
    });

    if (referenciaForm.foneResidencial) {
      arrayFones.push({
        ddd: referenciaForm.foneResidencial.substring(0, 2),
        numero: referenciaForm.foneResidencial.substring(2),
        idCategoria: '1',
        idTipoTelefone: '2',
        idCategoriaTelefone: '1',
      });
    }
    if (referenciaForm.foneOutro) {
      arrayFones.push({
        ddd: referenciaForm.foneOutro.substring(0, 2),
        numero: referenciaForm.foneOutro.substring(2),
        idCategoria: '15',
        idTipoTelefone: '2',
        idCategoriaTelefone: '2',
      });
    }

    return arrayFones;
  }

  onClickPrevious() {
    this.fichaCadastro.onClickPrevious();
  }

  get isEmailAvalista() {
    if (
      this.fichaCadastro._client.email &&
      this.fichaCadastro.avalistas.filter((avalista) => avalista.email).length >
        0
    ) {
      return this.fichaCadastro.avalistas.some((avalista) => {
        if (!avalista.email) {
          return;
        }
        return (
          avalista.email === this.fichaCadastro._client.email.toLowerCase()
        );
      });
    }
  }

  getDataNascimentoCliente() {
    return moment(this.fichaCadastro._client.dataNascimento?.replace(/\D/g, ""), 'DDMMYYYY');
  }

  onClickNext() {
    this.fichaCadastro._client.renda = this.fichaCadastro.rendaCliente;
    setFichaContent(this.fichaCadastro);
    this.fichaCadastro.onClickNext();
    this.putDataClient();
  }

  private putDataClient() {
    this.fichaService
      .putRecoverFullDataProposal(this.fichaCadastro.recoverData)
      .pipe(take(1))
      .subscribe();
  }

  formDetalheClienteValid(formDetalheCliente): boolean {
    if (!this.isPesados) {
      delete formDetalheCliente.value.tipoTransporte;
      delete formDetalheCliente.value.tipoTransporteOutro;
    }
    if (
      this.dadosProfissionaisComponent &&
      this.dadosProfissionaisComponent.errorMessage
    ) {
      return false;
    }
    return formDetalheCliente.valid;
  }

  get detalhesClienteValid(): boolean {
    return (
      !this.isEmailAvalista &&
      this.referenciaFormValid &&
      this.segundaReferenciaValid
    );
  }

  get segundaReferenciaValid(): boolean {
    if (this.isSelectedSegundaReferencia) {
      return this.segundaReferenciaFormValid;
    }

    return true;
  }

  get isPesados() {
    return this.fichaCadastro.tipoVeiculo === TipoVeiculoEnum.PESADOS;
  }

  assignFichaCadastroClient() {
    this.fichaCadastro.proposta.id = this.fichaCadastro.recoverData.proposal.id;
    this.fichaCadastro._client = new Cliente();
    this.fichaCadastro._client.id =
      this.fichaCadastro.recoverData.proposal.customer.id;
    this.getRecoverDataProposalAddressCustomer(
      this.fichaCadastro.recoverData.proposal.customer.addresses
    );
    this.getCompanyProvidingService(
      this.fichaCadastro.recoverData.proposal.customer.companyProvidingService
    );
    this.fichaCadastro._client.cpf =
      this.fichaCadastro.recoverData.proposal.customer.cpf;
    this.fichaCadastro._client.clientePpe =
      this.fichaCadastro.recoverData.proposal.customer.customerPpe;
    this.fichaCadastro._client.fatca =
      this.fichaCadastro.recoverData.proposal.customer.fatca;
    this.setFatcaIfSelected();
    this.fichaCadastro._client.clienteReferencias = this.getCustomerReferences(
      this.fichaCadastro.recoverData.proposal.customer.customerReferences
    );
    this.fichaCadastro._client.dataNascimento =
      this.fichaCadastro.formatDateToString(
        this.fichaCadastro.recoverData.proposal.customer.dateOfBirth &&
          this.fichaCadastro.recoverData.proposal.customer.dateOfBirth > 0
          ? new Date(
              this.fichaCadastro.recoverData.proposal.customer.dateOfBirth
            )
          : undefined
      );
    this.fichaCadastro._client.idTipoDocumento =
      this.fichaCadastro.recoverData.proposal.customer.documentTypeId;
    this.fichaCadastro._client.email =
      this.fichaCadastro.recoverData.proposal.customer.email;
    this.fichaCadastro._client.valorPatrimonio = Number(
      this.fichaCadastro.recoverData.proposal.customer.equityValue
    );
    this.fichaCadastro._client.nomePai =
      this.fichaCadastro.recoverData.proposal.customer.fatherName;
    if (this.fichaCadastro._client.nomePai === 'NAO DECLARADO') {
      this.onClickNomePaiCliente();
    }
    this.fichaCadastro._client.idEstadoCivil =
      this.fichaCadastro.recoverData.proposal.customer.idCivilStatus;
    this.fichaCadastro._client.renda =
      this.fichaCadastro.recoverData.proposal.customer.income;
    this.fichaCadastro._client.tipoEnderecoCorrespondencia =
      this.fichaCadastro.recoverData.proposal.customer.mailingAddressType;
    this.fichaCadastro._client.nomeMae =
      this.fichaCadastro.recoverData.proposal.customer.motherName;
    this.fichaCadastro._client.nome =
      this.fichaCadastro.recoverData.proposal.customer.name;
    this.fichaCadastro._client.idNacionalidade =
      this.fichaCadastro.recoverData.proposal.customer.nationalityId;
    this.fichaCadastro._client.naturalDe =
      this.fichaCadastro.recoverData.proposal.customer.naturalness;
    this.fichaCadastro._client.naturalDeUf =
      this.fichaCadastro.recoverData.proposal.customer.naturalnessFederalUnit;

    this.fichaCadastro._client.rgIe =
      this.fichaCadastro.recoverData.proposal.customer.rgIe;
    this.fichaCadastro._client.rgIeData = this.fichaCadastro.formatDateToString(
      this.fichaCadastro.recoverData.proposal.customer.rgIeDt &&
        this.fichaCadastro.recoverData.proposal.customer.rgIeDt > 0
        ? new Date(this.fichaCadastro.recoverData.proposal.customer.rgIeDt)
        : undefined
    );
    this.fichaCadastro._client.rgIeEmissor =
      this.fichaCadastro.recoverData.proposal.customer.rgIeIssuer;
    this.fichaCadastro._client.tipoTransporte =
      this.fichaCadastro.recoverData.proposal.customer.transportType;
    this.fichaCadastro._client.tipoTransporteOutro =
      this.fichaCadastro.recoverData.proposal.customer.othersTransportTypeDescription;
    if (
      this.fichaCadastro._client.tipoTransporte &&
      this.fichaCadastro._client.tipoTransporteOutro
    ) {
      this.showOutroTipoTransporteRecoverData = true;
    } else {
      this.showOutroTipoTransporteRecoverData = false;
    }
    this.fichaCadastro._client.condutorCaminhao =
      this.fichaCadastro.recoverData.proposal.customer.truckDriver;

    this.fichaCadastro.veiculoProprioCaminhao = this.getOwnVechicles(
      this.fichaCadastro.recoverData.proposal.customer.ownVehicles
    );

    this.fichaCadastro._client.dadoProfissional = this.parseProfessionalData(
      this.fichaCadastro.recoverData.proposal.customer.professionalData
    );

    this.fichaCadastro._client.telefones = this.getRecoverDataCustomerPhones(
      this.fichaCadastro.recoverData.proposal.customer.phones
    );

    if (
      this.fichaCadastro._client.telefones &&
      this.fichaCadastro._client.telefones.celularAdicional
    ) {
      this.fichaCadastro._client.telefones.celularAdicional =
        this.fichaCadastro._client.telefones.celularAdicional;
    }

    if (
      this.fichaCadastro._client.telefones &&
      this.fichaCadastro._client.telefones.celular
    ) {
      this.fichaCadastro._client.telefones.celular =
        this.fichaCadastro._client.telefones.celular;
    }

    if (
      this.fichaCadastro._client.telefones &&
      this.fichaCadastro._client.telefones.comercial
    ) {
      this.fichaCadastro._client.telefones.comercial =
        this.fichaCadastro._client.telefones.comercial;
    }

    if (
      this.fichaCadastro._client.telefones &&
      this.fichaCadastro._client.telefones.residencial
    ) {
      this.fichaCadastro._client.telefones.residencial =
        this.fichaCadastro._client.telefones.residencial;
    }

    this.fichaCadastro.proposta.cliente = this.fichaCadastro._client;
  }

  private getRecoverDataProposalAddressCustomer(
    address: RecoverDataProposalAddress[]
  ) {
    if (address && address.length > 0) {
      address.forEach((ref: RecoverDataProposalAddress) => {
        if (ref.correspondence) {
          this.fichaCadastro._client.enderecoCorrespondencia.endereco =
            ref.address;
          this.fichaCadastro._client.enderecoCorrespondencia.idTipoEndereco =
            ref.addressTypeId;
          this.fichaCadastro._client.enderecoCorrespondencia.cidade = ref.city;
          this.fichaCadastro._client.enderecoCorrespondencia.complemento =
            ref.complement;
          this.fichaCadastro._client.enderecoCorrespondencia.uf =
            ref.federalUnit;
          this.fichaCadastro._client.enderecoCorrespondencia.bairro =
            ref.neighborhood;
          this.fichaCadastro._client.enderecoCorrespondencia.numero =
            ref.number;
          this.fichaCadastro._client.enderecoCorrespondencia.condicaoResidencia =
            String(ref.residenceCondition);
          this.fichaCadastro._client.enderecoCorrespondencia.tempoResidencia =
            String(ref.residenceTime);
          this.fichaCadastro._client.enderecoCorrespondencia.cep =
            ref.singleZipCode;
        } else {
          (this.fichaCadastro._client.enderecos.endereco = ref.address),
            (this.fichaCadastro._client.enderecos.idTipoEndereco =
              ref.addressTypeId);
          this.fichaCadastro._client.enderecos.cidade = ref.city;
          this.fichaCadastro._client.enderecos.complemento = ref.complement;
          this.fichaCadastro._client.enderecos.uf = ref.federalUnit;
          this.fichaCadastro._client.enderecos.bairro = ref.neighborhood;
          this.fichaCadastro._client.enderecos.numero = ref.number;
          this.fichaCadastro._client.enderecos.condicaoResidencia = String(
            ref.residenceCondition
          );
          this.fichaCadastro._client.enderecos.tempoResidencia = String(
            ref.residenceTime
          );
          this.fichaCadastro._client.enderecos.cep = ref.singleZipCode;
          this.fichaCadastro.shouldSearchAddress = true;
        }
      });
    }
  }

  getOwnVechicles(
    data: RecoverDataProposalOwnVehicle[]
  ): PendenciaCaminhaoProprio[] {
    const retorno: PendenciaCaminhaoProprio[] = [];
    data.forEach((element) => {
      const info: PendenciaCaminhaoProprioInfo = {
        veiculoPlaca: element.plate,
        veiculoAno: `${element.modelYear}`,
        veiculoMarca: {
          id: `${element.brand.id}`,
          descricao: element.brand.description,
        },
        veiculoModelo: {
          id: `${element.model.id}`,
          descricao: element.brand.description,
        },
        veiculoVersao: {
          id: `${element.version.id}`,
          descricao: element.version.description,
        },
        tempoCaminhao: element.OwnsTime,
      };
      const quitado: PendenciaCaminhaoProprioQuitado = {
        veiculoQuitado:
          element.paid === 'S'
            ? true
            : element.amountParcels
            ? false
            : undefined,
        totalParcela: element.amountParcels,
        valorParcela: element.valueParcels,
        parcelasQuitada: element.amountPaidParcels,
        banco: {
          id: element.creditorName ? `${element.creditorName}` : undefined,
          descricao: '',
        },
      };
      const implemento: PendenciaCaminhaoProprioImplemento = {
        veiculoImplemento:
          element.hasImplement === 'S'
            ? true
            : element.OwnsTime
            ? false
            : undefined,
        veiculoAno: `${element.implementYear}`,
        veiculoMarca: {
          id: `${element.implementBrand}`,
          descricao: '',
        },
        veiculoModelo: {
          id: `${element.implementModel}`,
          descricao: undefined,
        },
      };
      retorno.push({ info, quitado, implemento });
    });

    return retorno;
  }

  private getRecoverDataProposalProfessionalData(
    dadosProfissonal: any
  ): RecoverDataProposalProfessionalData {
    const data: RecoverDataProposalProfessionalData =
      {} as RecoverDataProposalProfessionalData;
    if (dadosProfissonal && dadosProfissonal.idProfissao) {
      data.ProfessionId = dadosProfissonal.idProfissao;
      data.companyName = dadosProfissonal.nomeEmpresa;
      data.experienceIndustryTime =
        dadosProfissonal.tempoExperiencia.valorNumerico;
      data.familyInBusiness = dadosProfissonal.familiaresRamo;
      data.phone = dadosProfissonal.telefoneEmpresa;
      data.professionGroupId = dadosProfissonal.idGrupoProfissao;
      data.professionalClassId = dadosProfissonal.classeProfissional.id;
    }
    return data;
  }

  private getRecoverDataCustomerPhones(phones: any[]): TelefoneCliente {
    let data: TelefoneCliente = new TelefoneCliente();
    if (phones && phones.length > 0) {
      data = new TelefoneCliente(
        phones.map((phone) => ({
          categoria: { id: Number(phone.categoryId) },
          ddd: phone.ddd,
          telefone: phone.number,
        }))
      );
    }
    return data;
  }

  private getCompanyProvidingService(
    prestadora: RecoverDataProposalCompanyProvidingService
  ) {
    if (prestadora) {
      this.fichaCadastro._client.empresaPrestacaoServico.ddd = prestadora.ddd;
      this.fichaCadastro._client.empresaPrestacaoServico.nome = prestadora.name;
      this.fichaCadastro._client.empresaPrestacaoServico.telefone =
        prestadora.phone;
      this.fichaCadastro._client.empresaPrestacaoServico.tipoTransporte =
        prestadora.transportType;
      this.fichaCadastro._client.empresaPrestacaoServico.tipoTransporteOutro =
        prestadora.othersTransportTypeDescription;
    }

    if (this.fichaCadastro._client.empresaPrestacaoServico.tipoTransporte) {
      if (
        this.fichaCadastro._client.empresaPrestacaoServico.tipoTransporteOutro
      ) {
        this.showOutroTipoTransporteOutraEmpresaRecoverData = true;
      } else {
        this.showOutroTipoTransporteOutraEmpresaRecoverData = false;
      }
      this.fichaCadastro._client.prestaServicoOutraEmpresa = 'S';
    } else {
      this.showOutroTipoTransporteOutraEmpresaRecoverData = false;
      this.fichaCadastro._client.prestaServicoOutraEmpresa = 'N';
    }

    this.setPrestaServicoOutraEmpresaIfSelected();
  }

  private getCustomerReferences(
    reference: RecoverDataProposalCustomerReference[]
  ): Referencia[] {
    const data: Referencia[] = [];
    if (reference && reference.length > 0) {
      reference.forEach((ref: RecoverDataProposalCustomerReference) => {
        if (ref.phones[0]) {
          const telefone = new Telefone(
            ref.phones[0].ddd,
            ref.phones[0].number,
            ref.phones[0].categoryId,
            ref.phones[0].categoryPhoneId
          );
          data.push(
            new Referencia(ref.name, ref.relationshipDegreeId, telefone, '')
          );
        } else {
          data.push(new Referencia(ref.name, ref.relationshipDegreeId));
        }
      });
    }
    return data;
  }

  parseProfessionalData(
    data: RecoverDataProposalProfessionalData
  ): DadosProfissionais {
    if (data) {
      const dadosProfissionais = new DadosProfissionais();
      dadosProfissionais.classeProfissional = {
        id: data.professionalClassId,
        descricao: '',
        empresa: data.companyName ? true : false,
      };
      dadosProfissionais.profissao = {
        idGrupoProfissao: data.professionGroupId,
        id: data.ProfessionId,
        descricao: '',
      };
      dadosProfissionais.empresa = {
        nome: data.companyName,
        telefone: data.phone ? data.phone.ddd + data.phone.number : undefined,
        endereco: {
          idTipoEndereco: data.address ? data.address.addressTypeId : undefined,
          uf: data.address ? data.address.federalUnit : undefined,
          cidade: data.address ? data.address.city : undefined,
          endereco: data.address ? data.address.address : undefined,
          bairro: data.address ? data.address.neighborhood : undefined,
          numero: data.address ? data.address.number : undefined,
          complemento: data.address ? data.address.complement : undefined,
          cep: data.address ? data.address.singleZipCode : undefined,
          condicaoResidencia: String(
            data.address ? data.address.residenceCondition : ''
          ),
          tempoResidencia: String(
            data.address ? data.address.residenceTime : ''
          ),
          $cep: data.address ? data.address.singleZipCode : undefined,
          $idTipoEndereco: 1,
          condicaoResidenciaOutro: undefined,
        },
        valid: true,
      };
      dadosProfissionais.tempoExperiencia = {
        descricao: '',
        valorNumerico: data.experienceIndustryTime,
      };
      dadosProfissionais.familiaresRamo = data.familyInBusiness;
      this.dadosProfissionaisComponent.setDadosRecuperados(dadosProfissionais);
      return dadosProfissionais;
    }
    return null;
  }

  getDddAndCelular(value): { ddd: string; telefone: string } {
    if (!value || value === '') return { ddd: '', telefone: '' };
    const digits = onlyDigits(value);
    const ddd = digits.substring(0, 2);
    const telefone = digits.substring(2);
    return { ddd, telefone };
  }

  validCelphone(): AsyncValidatorFn {
    this.errorMessage = null;
    return (control: AbstractControl): Promise<ValidationErrors | null> => {
      if (!control.value || control.value.length === 0) {
        return Promise.resolve(null);
      }
      const dddCelular = this.getDddAndCelular(control.value);
      return this.fichaService
        .verifyCellPhone(dddCelular.ddd, dddCelular.telefone)
        .pipe(take(1))
        .toPromise()
        .then((res) => {
          if (res.status !== 'FAIL') {
            this.errorMessage = null;
            return null;
          }
          this.errorMessage = res.messages[0];
          return { genericErrorMessage: res.messages[0] };
        });
    };
  }

  clearErrorMessage(errorMessageName: string) {
    this[errorMessageName] = null;
  }

  validEmail(): AsyncValidatorFn {
    this.errorMessageEmail = null;
    return (control: AbstractControl): Promise<ValidationErrors | null> => {
      return this.fichaService
        .verifyEmail(control.value)
        .pipe(take(1))
        .toPromise()
        .then((res) => {
          if (res.status !== 'FAIL') {
            this.errorMessageEmail = null;
            return null;
          }
          this.errorMessageEmail = res.messages[0];
          return { genericErrorMessage: res.messages[0] };
        });
    };
  }
}
